import { render, staticRenderFns } from "./freeHome.vue?vue&type=template&id=39009af0&scoped=true"
import script from "./freeHome.vue?vue&type=script&lang=js"
export * from "./freeHome.vue?vue&type=script&lang=js"
import style0 from "./freeHome.vue?vue&type=style&index=0&id=39009af0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39009af0",
  null
  
)

export default component.exports